import { BasicContainerPropsInterface, BasicConfig } from '../../render/core/Container/types';
import { CSSProperties } from 'react';
import { IsBoolean } from 'class-validator';
import { PaginationProps } from '@native-ads/antd/lib/pagination';

export class TableColumnsItem {
    /**
     * 列头显示文字
     */
    title?: string;

    /**
     * 列数据在数据项中对应的 key，支持 a.b.c 的嵌套写法
     */
    dataIndex?: string;

    /**
     * 列的 className
     */
    className?: string;

    /**
     * 自定义渲染函数, 由组件自生成
     */
    render?: (text: any, record: DataSource, index: number) => React.ReactNode;

    /**
     * 列是否固定，可选 true(等效于 left) 'left' 'right'
     */
    fixed?: boolean | ('left' | 'right');

    /**
     * 列宽度
     */
    width?: string | number;

    style: CSSProperties;
}

export interface DataSource {
    [s: string]: any;
}

export class TableCustomerColumnControlItem {
    /**
     * 列数据在数据项中对应的Key
     */
    dataIndex: string;

    /**
     * 使用RCRE来进行自定义渲染
     */
    controls?: BasicConfig[];

    /**
     * 自定义渲染最外容器的className
     */
    className: string;

    /**
     * 自定义渲染最外层的内联CSS
     */
    style: CSSProperties;
}

export class TableConfig extends BasicConfig {
    /**
     * 是否显示外边看
     */
    @IsBoolean()
    bordered?: boolean;

    /**
     * 表格列的配置描述，具体项见下表
     */
    columns: TableColumnsItem[];

    /**
     * 数据数组
     */
    dataSource: DataSource[];

    /**
     * 是否是加载中
     */
    loading?: boolean;

    /**
     * 行的CSS class
     */
    rowClassName?: string;

    /**
     * 是否显示表头
     */
    showHeader?: boolean;

    /**
     * 表格标题
     */
    title?: string;

    /**
     * 是否含有分页
     */
    pagination?: PaginationProps | false;

    /**
     * 表格大小
     */
    size?: 'default' | 'middle' | 'small' | undefined;

    /**
     * 默认文案设置，目前包括排序、过滤、空数据文案
     */
    locale?: {
        filterConfirm: string,
        filterReset: string,
        emptyText: string,
    };

    /**
     * 展示树形数据时，每层缩进的宽度，以 px 为单位
     */
    indentSize?: number;

    /**
     * CSS样式
     */
    style?: CSSProperties;

    /**
     * CSS class
     */
    className?: string;

    /**
     * 列属性映射
     */
    columnsMapping?: TableColumnsItem;

    /**
     * 是否合并首列
     */
    mergeFirstColumn?: boolean;

    /**
     * 值属性映射
     */
    dataSourceMapping?: DataSource;

    /**
     * 表格扩展列
     */
    extendColumns?: TableColumnsItem[];

    /**
     * 指定对一些列进行自定义渲染
     */
    customerColumnControls?: TableCustomerColumnControlItem[];

    /**
     * 选取column的字段作为整行的表格行key
     */
    rowKey?: string;

    /**
     * 默认展开的行
     */
    expandedRowKeys?: string[];

    /**
     * 选择功能的配置
     */
    rowSelection?: {
        // 把选择框列固定在左边
        fixed?: boolean;

        // 去掉『全选』『反选』两个默认选项
        hideDefaultSelections?: boolean;

        // 指定选中项的 key 数 组，建议采用ExpressionString来赋值
        selectedRowKeys: string[];

        // 多选/单选
        type: 'checkbox' | 'radio';
    };

    /**
     * 固定表头
     */
    fixedHeader?: {
        /**
         * 固定的区域高度
         */
        fixedHeight?: number;

        /**
         * 固定的区域的宽度
         */
        fixedWidth?: number;
    };
}

export type RowSelectionItem = {
    // React Key
    key: string;

    // 选择项的文字
    text: string;
};

export class TablePropsInterface extends BasicContainerPropsInterface {
    info: TableConfig;
}

export interface TableStateInterface {
    total: number;
    current: number;
    expandedRowKeys: string[];
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Table/types.ts